import { render } from "./ModalErrorComponent.vue?vue&type=template&id=70a2e19c"
import script from "./ModalErrorComponent.vue?vue&type=script&lang=js"
export * from "./ModalErrorComponent.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__